'use strict';

var filterTaskByCategory = require('./filterTaskByCategory');

function filterBehaviour ($marketingChecklist, $filter) {
  $marketingChecklist = $marketingChecklist || $('.marketing-checklist');
  $marketingChecklist.find('.dropdown-menu li').removeClass('active');
  $filter.addClass('active');
  $marketingChecklist.find('.js-dropdown-button-label').text($filter.find('.name').text());
  return filterTaskByCategory(
    $marketingChecklist, $filter.attr('data-tasks-category')
  );
}

module.exports = filterBehaviour;
